import React from 'react'
import { redirectToCore } from '@helpers'
import { Button } from '../../UI'
import ClassroomMessage from './ClassroomMessage'

const ClassroomClosed = ({ threadId }) => {
  const goToChat = () => {
    redirectToCore(`/conversations/${threadId}`)
  }

  return (
    <div className='gp-ClassroomOnboarding'>
      <ClassroomMessage
        emoji='🔒'
        title='Classroom is closed'
        description='This session has ended and the classroom is closed.'
      />

      <Button
        className='gp-ClassroomMessage-actionButton'
        theme='c interactive'
        events={{ onClick: goToChat }}
        inverted
        icon={{
          name: 'arrow right long',
          value: 'Back to chat',
          group: 'a3'
        }}
      />
    </div>
  )
}

export default ClassroomClosed
